import { styled, Switch as MuiSwitch } from "@material-ui/core"

export const Switch = styled(MuiSwitch)({
  "& .MuiSwitch-thumb": {
    color: "#81FEB7"
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#1c2024"
  }
})
